import { useTranslation } from 'next-i18next'
import { FC, useState } from 'react'
import { GrCheckbox, GrCheckboxSelected } from 'react-icons/gr'

const ProductCompare: FC = () => {
  const { t } = useTranslation()
  const [isChecked, setIsChecked] = useState(false)

  const addToCompareListHandler = () => {
    setIsChecked(!isChecked)
  }

  return (
    <p
      className="text-brand font-medium flex items-center hover:cursor-pointer ml-3 mr-2"
      onClick={addToCompareListHandler}
    >
      {isChecked ? (
        <GrCheckbox fontSize={20} />
      ) : (
        <GrCheckboxSelected fontSize={20} />
      )}
      <span className="ml-1.5">{t('text-compare')}</span>
    </p>
  )
}

export default ProductCompare
